import { useCallback } from 'react'
import { DISPLAY_TIME_ZONE } from 'helpers/dates'

export const usePrintLedger = () => {
  const printLedger = useCallback((patientName?: string) => {
    const printWindow = window.open('', '_blank')

    if (!printWindow) {
      alert('Please allow pop-ups to print the ledger')
      return
    }

    const content = document.querySelector('[data-print-content]')

    if (!content) {
      console.error('Print content not found')
      printWindow.close()
      return
    }

    const styles = Array.from(document.styleSheets)
      .map((styleSheet) => {
        try {
          return Array.from(styleSheet.cssRules)
            .map((rule) => rule.cssText)
            .join('\n')
        } catch (e) {
          return ''
        }
      })
      .join('\n')

    const currentDate = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: DISPLAY_TIME_ZONE,
    })

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Patient Ledger${patientName ? ` - ${patientName}` : ''}</title>
          <style>
            ${styles}
            
            @page {
              size: A4;
              margin: 15mm 10mm;
            }
            
            body {
              margin: 0;
              padding: 0;
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            }
            
            * {
              box-sizing: border-box;
            }
            
            .print-header {
              margin-bottom: 24px;
              border-bottom: 2px solid #333;
              padding: 0 10mm 8px 0;
            }
            
            .print-header h1 {
              margin: 0 0 4px 0;
              font-size: 24px;
              font-weight: 600;
            }
            
            .print-header .date {
              margin: 0;
              color: #666;
              font-size: 10px;
            }
            
            .print-hide {
              display: none !important;
            }
            
            [data-print-content] {
              padding: 0 10mm;
            }
            
            [data-print-content] > div {
              margin-bottom: 8px;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 7px;
              page-break-inside: auto;
              table-layout: fixed;
            }
            
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
            
            thead {
              display: table-header-group;
            }
            
            tfoot {
              display: table-footer-group;
            }
            
            th, td {
              padding: 3px 4px;
              text-align: left;
              border: 0.5px solid #ccc;
              word-wrap: break-word;
              overflow: hidden;
            }
            
            th {
              background-color: #f5f5f5 !important;
              font-weight: 600;
              font-size: 7px;
              text-transform: uppercase;
              line-height: 1.2;
            }
            
            td {
              line-height: 1.3;
            }
            
            .category-header {
              background-color: #fff !important;
              border: none !important;
              padding: 8px 10mm 4px 10mm !important;
              font-size: 11px !important;
              font-weight: 600 !important;
              text-transform: none !important;
              page-break-after: avoid !important;
            }
            
            @media print {
              @page {
                size: A4;
                margin: 15mm 10mm !important;
              }
              
              body {
                padding: 0 !important;
                margin: 0 !important;
              }
              
              .no-print {
                display: none !important;
              }
              
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-header">
            <h1>Patient Ledger${patientName ? ` - ${patientName}` : ''}</h1>
            <p class="date">Generated on ${currentDate}</p>
          </div>
          ${content.innerHTML}
        </body>
      </html>
    `)

    printWindow.document.close()

    setTimeout(() => {
      printWindow.focus()
      printWindow.print()

      setTimeout(() => {
        printWindow.close()
      }, 100)
    }, 250)
  }, [])

  return { printLedger }
}

